module.exports = __webpack_public_path__ + "static/media/search-no-colleagues.c41460b8.svg";